<template>
  <div class="comment__header">
    <p>コメント</p>
    <button class="comment__close js-comment-close" @click="$parent.closeComment">
      <i class="las la-times"></i>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'f-comment-header'
  }
</script>
